const phoneBind = {
  path: 'phoneBind',
  component: resolve => require(['../../../../pages/home/user/phone-bind'], resolve)
}

export default phoneBind



// WEBPACK FOOTER //
// ./src/router/home/user/phone-bind/index.js